<footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-muted text-center text-md-left">Powered by &nbsp; <img height="20" style="margin-top: -5px;"
                                                                        src="assets/images/FM_Logo_sort_transp.png" alt=""></p>
  <p class="text-muted text-center text-md-left mb-0 d-none d-md-block">
    <a title="{{ coreConfig.appId }} - {{ coreConfig.gitHash }}"
       class="text-muted"
       [class.cursor-default]="getReleaseLogUrl(coreConfig.dominoConfig.releaselogurl) === null"
       [routerLink]="getReleaseLogUrl(coreConfig.dominoConfig.releaselogurl)"
       [queryParams]="getReleaseLogParams(coreConfig.dominoConfig.releaselogurl)">
      {{ coreConfig.buildNumber }}
    </a>
  </p>
</footer>
